import { render } from "./CreateGroupForm.vue?vue&type=template&id=66c45ebf&scoped=true"
import script from "./CreateGroupForm.vue?vue&type=script&lang=js"
export * from "./CreateGroupForm.vue?vue&type=script&lang=js"

import "./CreateGroupForm.vue?vue&type=style&index=0&id=66c45ebf&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c45ebf"]])

export default __exports__